import React, { useState } from "react";
import axios from "axios";
import { API_BASE } from "./api";

function GenerateLinkPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [files, setFiles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [link, setLink] = useState("");
const [uploadComplete, setUploadComplete] = useState(false);


 const handleUpload = async () => {
  const formData = new FormData();
  files.forEach(file => formData.append("photos[]", file));

  try {
    const res = await axios.post(`${API_BASE}/upload.php`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

   if (res.data.success && Array.isArray(res.data.filenames)) {
  setUploadedFiles(res.data.filenames);
  setUploadComplete(true); // NEW
}
else {
      alert("Upload failed");
    }
  } catch (error) {
    console.error("Upload Error:", error);
    alert("Upload error: " + error.message);
  }
};

 const handleGenerate = async () => {
  try {
    const res = await axios.post(`${API_BASE}/createlink.php`, {
      name,
      email,
      filenames: uploadedFiles
    });
    setLink(res.data.link);
  } catch (error) {
    console.error("Generate Link Error:", error);
    alert("Generate link error: " + error.message);
  }
};

 console.log("file",uploadedFiles);
  return (
    <div>
      <h2>Upload & Generate Link</h2>

      {/* Step 1: Upload Files */}
      <input type="file" multiple onChange={e => setFiles([...e.target.files])} />
      <button onClick={handleUpload}>Upload Photos</button>

      {/* Show thumbnails */}
      {uploadComplete && (
        <div style={{ display: "flex", flexWrap: "wrap", marginTop: 10 }}>
          {uploadedFiles.map((file, i) => (
            <img key={i} src={`${API_BASE}/uploads/${file}`} alt="" width={100} style={{ margin: 5 }} />
          ))}
        </div>
      )}

      {/* Step 2: Create User & Generate Link */}
    {uploadComplete && (
  <>
    <div style={{ marginTop: 20 }}>
      <input value={name} onChange={e => setName(e.target.value)} placeholder="Name" />
      <input value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" />
    </div>
    <button onClick={handleGenerate}>Generate Link</button>
  </>
)}

      {link && <p>Link: <a href={link}>{link}</a></p>}
    </div>
  );
}
export default GenerateLinkPage;
